import React, { useState } from 'react'
import { Search, XCircleFill } from 'react-bootstrap-icons'
import Select from 'react-select'

import { paySources } from '../../../types/part/partTypes'

import styles from './styles.module.scss'

interface TableHeadSelectPaySourceProps {
    selected: string | null
    onChange: (value: string | null) => void
}

const TableHeadSelectPaySource = ({ selected, onChange }: TableHeadSelectPaySourceProps) => {
    const [isEditing, setIsEditing] = useState(false)

    const selectedOption = paySources.find(opt => opt.value === selected) || null

    const handleChange = (option: { value: string; label: string } | null) => {
        setIsEditing(false)
        onChange(option?.value || null)
    }

    const handleReset = (e: React.MouseEvent) => {
        e.stopPropagation()
        onChange(null)
    }

    return (
        <div className={styles.headWrap}>
            <div className={styles.headContent} onClick={() => setIsEditing(true)}>
                <span>{'Источник'}</span>
                {selected ? (
                    <span className={styles.iconWrap} onClick={handleReset}>
                        <XCircleFill color="grey" size={14} />
                    </span>
                ) : (
                    <Search color="#C4C4C4" size={14} />
                )}
            </div>
            {isEditing && (
                <div className={styles.selectWrapper}>
                    <Select
                        autoFocus
                        menuIsOpen
                        options={paySources}
                        placeholder="Выберите оплату"
                        isClearable
                        value={selectedOption}
                        onChange={handleChange}
                        onBlur={() => setIsEditing(false)}
                        styles={{
                            control: provided => ({
                                ...provided,
                                borderColor: 'transparent',
                                boxShadow: 'none',
                                '&:hover': {
                                    borderColor: 'transparent',
                                },
                            }),
                        }}
                    />
                </div>
            )}
        </div>
    )
}

export default TableHeadSelectPaySource
